<template>
  <el-dialog :title="title" :visible="dialogFormVisible" width="40%" :before-close="handleClose" :closeOnClickModal="false">
        <el-form label-width="120px" ref="authModel" :model="authModel" :rules="rules">
            <el-form-item label="应用版本号" prop="AppVersion">
                <el-select v-model="authModel.AppVersion" placeholder="请选择">
                    <el-option
                        v-for="item in versionList"
                        :key="item"
                        :label="item"
                        :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="应用显示名称" prop="AppShowName">
                <el-input size="small" v-model="authModel.AppShowName" auto-complete="off" placeholder="请输入应用显示名称" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="应用类型授权" prop="AppState">
                <el-radio-group v-model="authModel.AppState">
                    <el-radio label="限时"></el-radio>
                    <el-radio label="永久"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="应用跳转路径" prop="Url">
                <el-input size="small" v-model="authModel.Url" auto-complete="off" placeholder="请输入应用显示名称" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="应用到期时间" prop="AppDueTime" v-if="authModel.AppState == '限时'">
                <el-date-picker
                    v-model="authModel.AppDueTime"
                    type="datetime"
                    placeholder="选择应用到期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="权限组" prop="RightGroup">
                <el-checkbox label="全部" v-if="authModel.RightGroup.length == 0" checked=""></el-checkbox>
                <el-checkbox-group v-model="authModel.RightGroup" >
                    <el-checkbox :label="item.RightName" v-for="(item,index) in rightGroupList" :key="index"></el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="排序" prop="Sort">
                <el-input size="small" v-model.number="authModel.Sort" auto-complete="off" placeholder="请输入版本说明" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="设置为屏保应用" prop="IsDefault">
                <el-switch v-model="authModel.IsDefault"></el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
            <el-button size="small" type="primary"  class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {UpdateDeviceApp,GetDeviceAppList,GetRightGroupList} from '../../../api/device'
import {GetAppLogList} from '../../../api/app'
export default {
    data() {
        return {
            title: '编辑设备应用',
            name: 'add',
            versionList: [],
            listCount: null,
            rightGroupList: [],
            authModel: {
                OID: null,
                AppShowName: null,
                AppVersion: '',
                AppState: '',
                AppDueTime: '',
                RightGroup: [],
                Sort: 0,
                IsDefault: false,
                CategoryID: null
            },
            versionModel: {
                Page: 1,
                Rows: 100,
                AppID: null
            },
            rules: {
                AppShowName: [{ required: true, message: '请输入应用显示名称', trigger: 'blur' }],
                AppVersion: [{ required: true, message: '请选择应用版本号', trigger: 'change' }],
                AppState: [{ required: true, message: '请选择应用授权类型', trigger: 'change' }],
                Sort: [{ required: true, message: '请输入应用排序', trigger: 'blur' ,type: 'number'}],
            },
        }
    },
    props: {
        dialogFormVisible: {
            required: true,
            type: Boolean
        },
        data: {
            required: true,
            type: Object
        },
        deviceOID: {
            required: true
        }
    },  
    mounted() {
        this.versionModel.AppID = this.data.AppID;
        this.GetAppLogList();
        this.GetRightGroupList();
        
    },
    methods: {
        //获取权限组列表
        GetRightGroupList() {
            let arr = [];
            GetRightGroupList({OID: this.deviceOID}).then(data=>{
                if(!data.iserror) {
                    this.rightGroupList = data.data.List;
                    this.authModel = this.data;
                    if(!this.authModel.RightGroup) {
                        this.authModel.RightGroup = []
                    }else{
                        let arr = [];
                        if(this.authModel.RightGroup.indexOf('|') != -1) {
                            arr = this.authModel.RightGroup.split('|');
                        }else{
                            arr = this.authModel.RightGroup.split(' ');
                        }
                        this.authModel.RightGroup = arr;
                    }
                }
            })
        },
        //获取应用版本列表
        GetAppLogList() {
            let arr = [];
            GetAppLogList(this.versionModel).then(data=>{
                if(!data.iserror) {
                    data.data.List.forEach(item=>{
                       arr.push(item.AppVersion)
                    })
                    this.versionList = arr;
                    this.listCount = data.data.Count;
                }
            })
        },
        handleSave() {
            this.$refs.authModel.validate((valid) => {
                if (valid) {
                        this.UpdateDeviceApp()
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'warning'
                    });
                }
            });
        },
        handleClose() {
            this.$emit('closeEditDialog')
        },
        UpdateDeviceApp() {
            if(this.authModel.RightGroup.length > 0) {
                let arr = this.authModel.RightGroup.join('|');
                this.authModel.RightGroup = arr;
            }
            UpdateDeviceApp(this.authModel).then(data=>{
                if(!data.iserror) {
                    this.$message({
                        message: '更新成功',
                        type: 'success'
                    });
                    this.handleClose();
                }
            })
        },
        done(input){
            var regex = /^[0-9A-Za-z]+$/;
            if (input.match(regex)) {
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>

<style>

</style>